<template>
    <div class="posts-wrapper home">
      <div class="info-home">
          <div class="title">Hola,</div>
          <div class="username">{{ userInfoData.name + ' '+ userInfoData.lastName }}</div>
          <div class="description">
            <p>{{userInfoData.welcomeMessage}}</p>
          </div>
      </div>
      <div class="packages">
        <div :class="['wrap-boxes',{'wrap-opacity': boxActive != null}]">
          <template v-for="(stat, index) in packageStats">
            <div :key="index" :class="['box st-' +stat.code,{'active': boxActive == stat.code}]">
              <span>{{stat.total}}</span>
              <p>{{stat.name}}</p>
            </div>
          </template>
        </div>
      </div>
      
      <div  v-if="packages.length > 0 && userInfoData.customerType != '03'">
        <br><br>
        <h2>Ultimos Paquetes</h2>
        <br><br>
      </div>

      <div class="box-white-wrapper" v-if="packages.length > 0 && userInfoData.customerType != '03'">
        <vs-table :data="tempPackges" pagination max-items="10">
            <template slot="header" v-if="userInfoData.role == Roles.Distribuitor">
                <div class="extra-actions">
                    <vs-button
                        color="primary"
                        type="border"
                        icon="cached"
                        @click="openModalSurveyBulk()"
                        v-if="updateMultiplePacks.length > 0"
                        >Confirmar entrega ({{ updateMultiplePacks.length }})</vs-button
                    >
                </div>
            </template>
            <template slot="thead">
                <th v-if="userInfoData.role == Roles.Distribuitor"></th>
                <vs-th sort-key="tracking">Tracking</vs-th>
                <vs-th sort-key="firstName">Nombre </vs-th>
                <vs-th sort-key="email">Email </vs-th>
                <vs-th sort-key="createdAt"> Fecha Registro </vs-th>
                <vs-th sort-key="statusname"> Estado </vs-th>
                <vs-th sort-key="id" class="width-30"></vs-th>
            </template>
            <template slot-scope="{data}">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data" >
                <vs-td class="switchMultiplePacks" v-if="userInfoData.role == Roles.Distribuitor">
                    <vs-checkbox color="#1a426d" v-model="updateMultiplePacks" :vs-value="data[indextr].id"></vs-checkbox>
                </vs-td>
                <vs-td :data="data[indextr].tracking">
                  <div class="d-flex">
                    <div :class="['circle', data[indextr].permission === 1 ? 'st-warning' : '']"></div>
                    {{data[indextr].tracking}}
                  </div>
                </vs-td>
                <vs-td :data="data[indextr].firstName">
                    {{data[indextr].firstName +' '+ data[indextr].lastName}}
                </vs-td>
                <vs-td :data="data[indextr].email">
                    <a :href="`mailto:${data[indextr].email}`">{{data[indextr].email}}</a>
                </vs-td>
                <vs-td :data="data[indextr].createdAt">
                    {{data[indextr].createdAt | moment('DD/MM/YYYY')}}
                </vs-td>
                <vs-td :data="data[indextr].statuscode">
                    <span :class="`status status-${data[indextr].statuscode}`" @click="changePackageStatus(data[indextr].id)">
                        {{data[indextr].displayName}}
                    </span>
                </vs-td>
                <vs-td :data="data[indextr].id">
                    <div class="table-actions" v-if="userInfoData.role != Roles.Distribuitor">
                          <router-link :to="`/package/${data[indextr].id}`"><feather type="eye"/></router-link>
                    </div>
                </vs-td>
                </vs-tr>
            </template>
        </vs-table>
      </div>
      <modalPackage @modal-event="handleActionModalPackage" :packID="packageId" :selected="pkgCurrentStatus" :show="modalActive"></modalPackage>
      <modal-survey @modal-event="handleActionModalSurvey" :packID="packageId" :packIDs="packIDsSurvey" :customer="customerId" :show="modalActiveSurvey"></modal-survey>
      <displayInformation v-if="packages.length < 1" message="No se han encontrado paquetes registrados." :showButton="true"></displayInformation>
      <!-- <modalNewToUser @modal-event="handleCloseNew" :show="modalNew"></modalNewToUser> -->
    
    </div>
</template>
<script>
import { mapState, } from 'vuex'
import {helper} from '@/helpers/utils'
import { Role } from '@/helpers/Role.js'
import PackageModel from "@/models/PackageModel"
import { required } from 'vuelidate/lib/validators'
import PackageDataService from "@/services/PackageDataService"
import ModalPackage from '@/components/Modal/PackageStatus.vue'
import ModalSurvey from '@/components/Modal/UserSurvey.vue'
// import modalNewToUser from '@/components/Modal/NewToUser.vue'

import DisplayInformation from '@/components/DisplayInformation.vue'
export default {
  name: 'Home',
  mixins: [helper],
  components: {
    ModalPackage,
    ModalSurvey,
    // modalNewToUser,
    DisplayInformation
  },
  data () {
    return {
      pkgCurrentStatus:{},
      modalActive: false,
      confirmStatus: false,
      searchkeyword: '',
      message: '',
      postId: 0,
      page: 1,
      countPost:0,
      packageStats: [],
      packID: 0,
      newStatus: {},
      package: new PackageModel(),
      packages: [],
      tempPackges: [],
      Roles: [],
      boxActive: null,
      packageId: "",
      customerId: "",
      packIDsSurvey: [],
      updateMultiplePacks: [],
      modalActiveSurvey: false,
      modalNew: false
    }
  },
  created(){
    this.Roles = Role
    
  },
  computed: {
    ...mapState([
      'userInfoData'
    ]),
  },
  beforeMount() {
    this.$Progress.start();
  },
  mounted (){
    console.log();
    if(this.userInfoData.role == 'Warehouse'){
      this.$router.push({ name: "inventoryAdd"})
    }
    this.retrievePackages()
    let readNote = localStorage.getItem('readNew');
    if(readNote == null){
      this.modalNew = true;
    }
    this.getPackagesStats();
  },
  validations: {
    package: 
      { 
        status: { required },
      },
  },
  methods: {
    handleCloseNew(){
      localStorage.setItem('readNew', 1);
      this.modalNew = false
    },
    handleActionModalPackage(response){
      if(response.error !=  undefined){
        if(!response.error){
          this.retrievePackages()
          this.$vs.notify({title:'Información!',text:'El estado del paquete fue modificado exitosamente!',color:'success',icon:'check'})
        }else{
            this.$vs.notify({title:'Información!',text:'Error actualizando el estado del paquete',color:'danger',icon:'error_outline'})
        }
      }
      this.modalActive = response.active
      
    },
    handleActionModalSurvey(response){
      if(response.error !=  undefined){
        if(!response.error){
          this.updateMultiplePacks = []
          this.retrievePackages()
          this.$vs.notify({title:'Información!',text: this.packIDsSurvey.length > 1 ? 'Los paquetes fueron entregados exitosamente!' : 'El paquete fue entregado exitosamente!',color:'success',icon:'check'})
        }else{
            this.$vs.notify({title:'Información!',text:'Error actualizando el estado del paquete',color:'danger',icon:'error_outline'})
        }
      }
      this.modalActiveSurvey = response.active
      if(!response.active) this.packIDsSurvey = []
    },
    changePackageStatus(value){
      if(this.userInfoData.role == this.Roles.Distribuitor){
        let _objPack = this.packages.find((item) => item.id === value)
        this.packageId = value
        this.customerId = _objPack ? _objPack.cu01Id : ""
        this.packIDsSurvey = []
        this.modalActiveSurvey = true
        return
      }
      if(this.userInfoData.role != 'Customer'){
        this.packageId   = value
        this.pkgCurrentStatus = this.currentPackStatus(value)
        this.modalActive = true
      }
    },
    openModalSurveyBulk(){
      if(this.updateMultiplePacks.length === 0) return
      let _custIds = [...new Set(this.updateMultiplePacks.map(id => {
        let _objPack = this.packages.find((item) => item.id === id)
        return _objPack ? _objPack.cu01Id : null
      }))]
      if(_custIds.length > 1 || _custIds.some(id => id == null)){
        this.$vs.notify({title:'Información!',text:'Selecciona paquetes de un mismo cliente para procesarlos juntos.',color:'warning',icon:'error_outline'})
        return
      }
      this.packageId = String(this.updateMultiplePacks[0])
      this.customerId = _custIds[0]
      this.packIDsSurvey = [...this.updateMultiplePacks]
      this.modalActiveSurvey = true
    },
    currentPackStatus(id) {
        let _objPack = this.packages.filter((item) => {
          return id === item.id
        })
        _objPack =  _objPack[0]
        let newStatus = { id: _objPack.statuscode, name: _objPack.statusname}
        return newStatus
    },
    retrievePackages() {
        PackageDataService.getAll({limit: 20})
        .then(response => {
          this.packages    = response.data;
          this.tempPackges = this.packages
          this.$Progress.finish()
          this.$vs.loading.close('.vs-con-loading__container .con-vs-loading')
        })
        .catch(e => {
          console.log(e)
          this.$Progress.finish()
          this.$vs.loading.close('.vs-con-loading__container .con-vs-loading')
          this.$vs.notify({title:'Error!',text:'Error obteniendo los paquetes!',color:'danger',icon:'error_outline'})
        });
    },
    getPackagesStats() {
        PackageDataService.getPackagesUser()
        .then(response => {
            this.packageStats = response.data;
        })
        .catch(e => {
            console.log(e)
            this.$vs.notify({title:'Error!',text:'Error obteniendo las estadisticas de los clientes!',color:'danger',icon:'error_outline'})
        });
    },
  }
}
</script>
